import React from 'react';

export default function ReportFunctional({ functionalIntegrity }) {
  const description = ["", "PASS", "FAIL"]
  const fontColor = ["white", "green", "red"]
  return(
    <div className="report-section">
      <h2>Functional Integrity Assessment</h2>
      <table>
        <tbody>
          <tr>
            <th>Function</th>
            <th>Status</th>
          </tr>
          <tr>
            <td>Air Conditioner</td>
            <td style={{fontWeight:"bold", color:fontColor[functionalIntegrity.airConditioner]}}>{description[functionalIntegrity.airConditioner]}</td>
          </tr>
          <tr>
            <td>Infotainment System</td>
            <td style={{fontWeight:"bold", color:fontColor[functionalIntegrity.infotainment]}}>{description[functionalIntegrity.infotainment]}</td>
          </tr>
          <tr>
            <td>Speakers</td>
            <td style={{fontWeight:"bold", color:fontColor[functionalIntegrity.speakers]}}>{description[functionalIntegrity.speakers]}</td>
          </tr>
          <tr>
            <td>Rear and Front Lights</td>
            <td style={{fontWeight:"bold", color:fontColor[functionalIntegrity.rearAndFrontLights]}}>{description[functionalIntegrity.rearAndFrontLights]}</td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

